import React, { Component } from "react";
import { connect } from "react-redux";
import { getProfileData } from "../../../store/actions/profile";
import {
  getMisContributed,
  getMisCompleted,
  getMisPending,
} from "../../../store/actions/nps";
import { Paper, Tooltip } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Signbutton from "../../forms/button";
import { format } from "date-fns";
import MisTable from "./MisTables";
import CustomLoader from "../../forms/Loader";
import { ArrowBack } from "@material-ui/icons";
import Image from "../../Image";
import { NPS_URL } from ".";
import {
  CompletedSubscriberss,
  Contributedsubscriberss,
  PendingSubscriberss,
} from "./testdata";
const ReportType = {
  CN: "Contribution",
  CM: "Completed PRAN",
  P: "Pending PRAN",
};

class MisReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        1
      ),
      endDate: new Date(),
      isLoading: false,
      reportsData: [],
      link: "",
    };
  }
  getMisData = async () => {
    this.setState({ isLoading: true });
    const { state } = this.props.location;
    const { type } = state;
    const Arn = this.props.token.replace("ARN-", "");
    const diff = 8 - Arn.length;
    const ArnNumber = "0".repeat(diff) + Arn;
    this.setState({ loading: true });
    await this.props.getProfileData({
      Agent: this.props.token,
      UserId: this.props.userId,
    });
    const { PAN } = this.props.profileData;
    const AgentReferenceNumber = PAN + ArnNumber;
    const params = {
      AgentReferenceNumber,
      FromDate: format(this.state.startDate, "dd/MM/yyyy"),
      toDate: format(this.state.endDate, "dd/MM/yyyy"),
    };
    var response;
    var result;
    var Status;

    try {
      switch (type) {
        case "CN":
          response = await this.props.getMisContributed(params);
          result = JSON.parse(response.body);
          Status = result.Status || [{ Code: "1" }];
          if (!!Status && parseInt(Status[0].Code) === 0) {
            const { ContributedSubscribers } = result;
            const sortedContributedSubscribers = ContributedSubscribers.map(
              (s) => {
                return {
                  "Subscriber Name": s["Subscriber Name"],
                  PRAN: s["PRAN"],
                  "PRAN Generation Date": s["PRAN generation Date"],
                  "Contribution Type": s["Contribution type"],
                  "Contribution Amount": s["Cont AMount"],
                  "POP Charges": "₹" + s["POP Charges"],
                  "Tier Type": s["Tier Type"],
                  Source: s["Source"],
                };
              }
            );
            this.setState({ reportsData: sortedContributedSubscribers });
            this.download();
          } else if (this.props.token === "ARN-0018") {
            const sortedContributedSubscribers = Contributedsubscriberss.map(
              (s) => {
                return {
                  "Subscriber Name": s["Subscriber Name"],
                  PRAN: s["PRAN"],
                  "PRAN Generation Date": s["PRAN generation Date"],
                  "Contribution Type": s["Contribution type"],
                  "Contribution Amount": s["Cont AMount"],
                  "POP Charges": "₹" + s["POP Charges"],
                  "Tier Type": s["Tier Type"],
                  Source: s["Source"],
                };
              }
            );
            this.setState({ reportsData: sortedContributedSubscribers });
            this.download();
          }
          break;
        case "P":
          response = await this.props.getMisPending(params);
          result = JSON.parse(response.body);
          Status = result.Status || [{ Code: "1" }];
          if (!!Status && parseInt(Status[0].Code) === 0) {
            const { PendingSubscribers } = result;
            const sortedPendingSubscribers = PendingSubscribers.map((s) => {
              return {
                "Subscriber Name": s["Subscriber Name"],
                "Subscriber PAN": s["Subscriber PAN"],
                "Mobile Number": s["Mobile Number"],
                "EMail ID": s["EMail ID"].toLowerCase(),
                "Pending At": s["Pending At"],
              };
            });
            this.setState({ reportsData: sortedPendingSubscribers });
            this.download();
          } else if (this.props.token === "ARN-0018") {
            const sortedPendingSubscribers = PendingSubscriberss.map((s) => {
              return {
                "Subscriber Name": s["Subscriber Name"],
                "Subscriber PAN": s["Subscriber PAN"],
                "Mobile Number": s["Mobile Number"],
                "EMail ID": s["EMail ID"].toLowerCase(),
                "Pending At": s["Pending At"],
              };
            });
            this.setState({ reportsData: sortedPendingSubscribers });
            this.download();
          }
          break;
        case "CM":
          response = await this.props.getMisCompleted(params);
          result = JSON.parse(response.body);
          Status = result.Status || [{ Code: "1" }];
          if (!!Status && parseInt(Status[0].Code) === 0) {
            const { CompletedSubscribers } = result;
            const sortedCompletedSubscribers = CompletedSubscribers.map((s) => {
              return {
                "Subscriber Name": s["Subscriber Name"],
                PRAN: s["PRAN"],
                "Subscriber PAN": s["Subscriber PAN"],
                "Mobile Number": s["Mobile Number"],
                "EMail ID": s["EMail ID"].toLowerCase(),
                "POP Charges": "₹" + s["POP Charges"],
                "PRAN generation Date": s["PRAN generation Date"],
              };
            });
            this.setState({ reportsData: sortedCompletedSubscribers });
            this.download();
          } else if (this.props.token === "ARN-0018") {
            const sortedCompletedSubscribers = CompletedSubscriberss.map(
              (s) => {
                return {
                  "Subscriber Name": s["Subscriber Name"],
                  PRAN: s["PRAN"],
                  "Subscriber PAN": s["Subscriber PAN"],
                  "Mobile Number": s["Mobile Number"],
                  "EMail ID": s["EMail ID"].toLowerCase(),
                  "POP Charges": "₹" + s["POP Charges"],
                  "PRAN generation Date": s["PRAN generation Date"],
                };
              }
            );
            this.setState({ reportsData: sortedCompletedSubscribers });
            this.download();
          }
          break;
        default:
          return;
      }
    } catch (e) {
      console.log(e);
      alert(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };
  async componentDidMount() {
    this.getMisData();
  }

  onDateChange(d, e) {
    this.setState({
      [d]: e,
    });
  }

  download = () => {
    const testdata = this.state.reportsData;
    if (testdata.length > 0) {
      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      const header = Object.keys(testdata[0]);
      const csv = [
        header.join(","), // header row first
        ...testdata.map((row) =>
          header
            .map((fieldName) => JSON.stringify(row[fieldName], replacer))
            .join(",")
        ),
      ].join("\r\n");
      var csvFile = new Blob(["\uFEFF" + csv], {
        type: "text/csv; charset=utf-18",
      });
      const downloadLink = URL.createObjectURL(csvFile);
      this.setState({ link: downloadLink });
    } else {
      alert("No Data to Download");
    }
  };

  render() {
    const { state } = this.props.location;
    const { type } = state;
    return (
      <Paper
        className="container-margin"
        style={{
          boxShadow: "0px 0px 2px 0px lavender",
          margin: 0,
          padding: "30px",
        }}
      >
        <CustomLoader display={this.state.isLoading} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="investor-title">{`${ReportType[type]} Report`}</div>
          <span
            style={{
              padding: "12px",
              fontFamily: "OpenSans-SemiBold",
              color: "#007ac8",
              marginRight: "50px",
            }}
          >
            Available Records : {this.state.reportsData.length}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <div className="flex w-100">
            <div className="dual-margin mis-date">
              <div className="input-name">Start Date</div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required={true}
                  className="selects"
                  style={{
                    margin: "0px 0px 20px 0px",
                  }}
                  onChange={(e) => this.onDateChange("startDate", e)}
                  disableFuture={true}
                  minDate={"January 1, 2022"}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  id="mui-pickers-date"
                  value={this.state.startDate}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="dual-margin mis-date">
              <div className="input-name">End Date</div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required={true}
                  className="selects"
                  style={{
                    margin: "0px 0px 20px 0px",
                  }}
                  onChange={(e) => this.onDateChange("endDate", e)}
                  disableFuture={true}
                  format="dd/MM/yyyy"
                  minDate={this.state.startDate}
                  maxDate={new Date()}
                  id="mui-pickers-date"
                  value={this.state.endDate}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="dual-margin mis-date">
              <Signbutton
                buttontitle={"Submit"}
                onClick={this.getMisData}
                width="100%"
              />
            </div>
            {this.state.reportsData.length > 0 && (
              <div className="dual-margin mis-date">
                <a
                  href={this.state.link}
                  download={`${ReportType[type]} Report`}
                >
                  <Tooltip title="Download as Excel">
                    <Image
                      src={"/images/excel_icon.svg"}
                      className="mis-icon"
                      alt="download"
                      onClick={this.download}
                    />
                  </Tooltip>
                </a>
              </div>
            )}
          </div>
          <Tooltip title="Back">
            <ArrowBack
              style={{
                cursor: "pointer",
                marginTop: "40px",
                marginRight: "20px",
                height: "36px",
                color: "#007ac8",
              }}
              onClick={() => this.props.history.push(NPS_URL + "/mis")}
            />
          </Tooltip>
        </div>
        {!!this.state.reportsData.length ? (
          <MisTable data={this.state.reportsData} />
        ) : (
          <span
            style={{
              color: "red",
              fontFamily: "OpenSans-SemiBold",
              marginLeft: "35%",
            }}
          >
            No Data Found
          </span>
        )}
      </Paper>
    );
  }
}

export default connect(
  ({ authReducer, profileReducer }) => {
    const { token, userId } = authReducer;
    const { profileData } = profileReducer;
    return {
      token,
      userId,
      profileData,
    };
  },
  {
    getProfileData,
    getMisContributed,
    getMisPending,
    getMisCompleted,
  }
)(MisReports);
